import styled from 'styled-components';

const MainContainer = styled.main`
  flex: 1;
  overflow: auto;
  height: 100%;
`;

export default MainContainer;
